import { Card, CardBody, Container, Table } from "reactstrap";
// import InvoiceFiveSign from "../Invoice-5/InvoiceFiveSign";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import { useCallback, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { URL_API } from "../../../../../utils/helper/helpers";
import Breadcrumbs from "../../../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Email, Invoice, InvoiceFour, InvoiceHeading, InvoiceTo, PaymentTeams, Phone, TotalDue, Website } from "../../../../../utils/Constant";
import { H4, UL, LI, P } from "../../../../../AbstractElements";
import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service";
import axios from "axios";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { formatDate, formatPhoneNumber, formatPrice } from "../../../../../utils/helper/helpers";

interface Vente {
  id: number;
  produit_id: number;
  quantite: number;
  prix_unitaire: number;
  prix_total: number;
  date_vente: string;
  client_id: number;
  created_at: string | null;
  updated_at: string | null;
  name: string;
  phone: string;
  email: string;
  address: string;
  produit_count: number;
  vente_total: number;
}

interface Produit {
  id: number;
  produit_id: number;
  quantite: number;
  prix_unitaire: number;
  prix_total: number;
  date_vente: string;
  client_id: number;
  created_at: string | null;
  updated_at: string | null;
  libelle: string;
}

interface Ets {
  id: number;
  nom: string;
  telephone: string;
  email: string;
  description: string;
  adresse: string;
  status: string;
  created_at: string;
  updated_at: string;
  is_default: number;
}

interface ApiResponse {
  vente: Vente;
  produits: Produit[];
  ets: Ets;
}


const InvoiceFourContainer = () => {
  const componentRef = useRef<HTMLDivElement | null>(null);
  const [data, setData] = useState<ApiResponse | null>(null);
  const { id } = useParams();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  // Fetch data from API
  const FetchVentes = useCallback(async () => {
    try {
      const Token = JSON.parse(localStorage.getItem("login")!);
      const response = await axios.get(`${URL_API}/vente/get/${id}`, {
        headers: { Authorization: `Bearer ${Token}` }
      });
      if (response.data.success) {
        setData(response.data);
      }
    } catch (error: any) {
      const message = error.response?.data?.message || "Erreur inconnue";
      toast.error(message);
    }
  }, []);

  // Initial data fetch
  useEffect(() => {
    FetchVentes();
  }, [FetchVentes]);


  return (
    <>
      <Breadcrumbs mainTitle={InvoiceFour} parent={Invoice} />

      <Container className="invoice-2">
        <Card>
          <div ref={componentRef}>

            <CardBody>
              <Table className="table-wrapper theme-scrollbar" responsive borderless>
                <tbody>
                  <tr>
                    <td className="p-0">
                      <Table responsive style={{ width: "100%" }} borderless>
                        <tbody>
                          <tr style={{ padding: "28px 0 5px", display: "flex", justifyContent: "space-between" }} >
                            <td className="p-0">
                              <H4 style={{ fontSize: 42, fontWeight: 600, color: "#2E8DD3", margin: 0 }} >
                                {InvoiceHeading}
                              </H4>
                              <UL style={{ listStyle: "none", gap: 15, padding: 0, margin: "20px 0" }} className="simple-list flex-row">
                                <LI className="p-0">
                                  <span style={{ fontSize: 16, fontWeight: 600, opacity: "0.8" }} >
                                    {InvoiceTo} :
                                  </span>
                                </LI>
                                <LI className="p-0">
                                  <span style={{ fontWeight: 600, fontSize: 16, color: "#2E8DD3", display: "block", marginBottom: 8 }}>
                                    {data?.vente.name}
                                  </span>
                                  <span style={{ width: "75%", display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, opacity: "0.8" }} >
                                    Adresse : {data?.vente.address}
                                  </span>
                                  <span style={{ lineHeight: "1.9", fontSize: 16, fontWeight: 400, opacity: "0.8", display: "block" }} >
                                    {Phone} : {formatPhoneNumber(data?.vente.phone)}
                                  </span>
                                  <span style={{ lineHeight: "1.7", fontSize: 16, fontWeight: 400, opacity: "0.8", display: "block" }} >
                                    {Email} : {data?.vente.email}
                                  </span>
                                </LI>
                              </UL>
                            </td>
                            <td className="p-0">
                              <Image className="img-fluid for-light" src={dynamicImage("logo/logoetsdetf.png")} alt="logo" style={{ height: "50px", marginBottom: 14 }} />
                              <Image className="img-fluid for-dark" src={dynamicImage("logo/dark-logo.png")} alt="logo" style={{ height: "50px", marginBottom: 14 }} />
                              <span style={{ display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, opacity: "0.8" }} >
                                Adresse : {data?.ets.adresse}
                              </span>
                              <span style={{ display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, opacity: "0.8" }} >
                                {Phone} : {formatPhoneNumber(data?.ets.telephone)}
                              </span>
                              <span style={{ display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, opacity: "0.8" }} >
                                {Email} : {data?.ets.email}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-0">
                      <Table responsive borderless style={{ width: "100%", borderSpacing: 4, marginBottom: 20 }}>
                        <tbody>
                          <tr>
                            <td style={{ background: "#2E8DD31a", padding: "15px 25px" }}>
                              <P style={{ fontSize: 16, fontWeight: 500, color: "#2E8DD3", opacity: "0.8", margin: 0, lineHeight: 2 }}>
                                Date :
                              </P>
                              <span style={{ fontSize: 16, fontWeight: 600 }}>
                                {formatDate(data?.vente.date_vente ? new Date(data.vente.date_vente) : undefined)}
                              </span>
                            </td>
                            <td style={{ background: "#2E8DD31a", padding: "15px 25px" }}>
                              <P style={{ fontSize: 16, fontWeight: 500, color: "#2E8DD3", opacity: "0.8", margin: 0, lineHeight: 2 }}>
                                Facture No :
                              </P>
                              <span style={{ fontSize: 16, fontWeight: 600 }}>
                                #{data?.vente.id}
                              </span>
                            </td>
                            <td style={{ background: "#2E8DD31a", padding: "15px 25px" }}>
                              <P style={{ fontSize: 16, fontWeight: 500, color: "#2E8DD3", opacity: "0.8", margin: 0, lineHeight: 2 }}>
                                Montant Total :
                              </P>
                              <span style={{ fontSize: 16, fontWeight: 600 }}>
                                {formatPrice(data?.vente.vente_total)}
                              </span>
                            </td>
                            <td style={{ background: "#2E8DD31a", padding: "15px 25px" }}>
                              <P style={{ fontSize: 16, fontWeight: 500, color: "#2E8DD3", opacity: "0.8", margin: 0, lineHeight: 2 }}>
                                Nombre Produit :
                              </P>
                              <span style={{ fontSize: 16, fontWeight: 600 }}>
                                {data?.vente.produit_count.toLocaleString("gn-GN")} Produit.s
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-0">
                      <Table responsive style={{ width: "100%", borderSpacing: 0 }} >
                        <thead>
                          <tr style={{ background: "#2E8DD3" }}>
                            <th style={{ padding: "15px 15px", textAlign: "left", position: "relative", borderTopLeftRadius: 10 }}>
                              <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }} >
                                Descriptions
                              </span>
                            </th>
                            <th style={{ padding: "15px 15px", textAlign: "center", borderTopLeftRadius: 0 }}>
                              <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }} >
                                Prix Unitaire
                              </span>
                            </th>
                            <th style={{ padding: "15px 15px", textAlign: "center", borderTopLeftRadius: 0 }}>
                              <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }} >
                                Quantités
                              </span>
                            </th>
                            <th style={{ padding: "15px 15px", textAlign: "center", borderTopLeftRadius: 0 }}>
                              <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }} >
                                Montant
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.produits.map((data, i) => (
                            <tr key={i}>
                              <td style={{ padding: 20 }}>
                                <H4 style={{ fontWeight: 600, margin: "0px 0px", fontSize: 16, color: "#2E8DD3" }}>
                                  {data.libelle}
                                </H4>
                              </td>
                              <td className="p-0" style={{ width: "12%", textAlign: "center" }}>
                                <span style={{ opacity: "0.8" }}>{formatPrice(data.prix_unitaire)}</span>
                              </td>
                              <td className="p-0" style={{ width: "12%", textAlign: "center" }}>
                                <span style={{ opacity: "0.8" }}>{data.quantite.toLocaleString("gn-GN")}</span>
                              </td>
                              <td className="p-0" style={{ width: "12%", textAlign: "center" }}>
                                <span style={{ color: "#2E8DD3", fontWeight: 600, opacity: "0.9" }} >
                                  {formatPrice(data.prix_total)}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                  <tr style={{ height: 3, width: "100%", background: "linear-gradient(90deg, #2E8DD3 20.61%, #2E8DD3 103.6%)", display: "block", marginTop: 6 }}>
                  </tr>
                  <tr>
                    <td className="p-0">
                      <Table style={{ width: "100%" }}>
                        <tbody>
                          <tr style={{ display: "flex", justifyContent: "space-between", margin: "16px 0 24px 0", alignItems: "end" }} >
                            <td className="p-0" style={{ display: "flex", gap: 10 }}>
                              <span style={{ color: "#2E8DD3", fontSize: 16, fontWeight: 600 }}>
                                {PaymentTeams} :
                              </span>
                              <span style={{ display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, width: "55%" }} >
                                {"Il s'agit d'un paiement pour un achat complet."}
                              </span>
                            </td>
                            <td className="p-0">
                              <UL style={{ padding: 0, margin: 0, listStyle: "none" }} >
                                <LI className="p-0" style={{ display: "flex", alignItems: "center" }}>
                                  <span style={{ display: "block", width: 95, fontSize: 20 }}>{TotalDue}</span>
                                  <span style={{ display: "block", color: "#2E8DD3", opacity: "0.9", fontWeight: 600, padding: "12px 25px", borderRadius: 5, background: "rgba(67, 185, 178 , 0.1)", fontSize: 18 }} >
                                    {formatPrice(data?.vente.vente_total)}
                                  </span>
                                </LI>
                              </UL>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                </tbody>
              </Table>

            </CardBody>
          </div>

        </Card>
      </Container>
      <InvoiceButtons handlePrint={handlePrint} />
    </>
  );
};

export default InvoiceFourContainer;
